import { LiveChatSVG } from '../../../svgComponents/liveChatSVG/LiveChatSVG';

// eslint-disable-next-line import/no-default-export
export default [
    {
        title: "What if I can't repay?",
        description: (
            <>
                If you have trouble repaying, let us know so we can work with
                you to find a solution. We might be able to lower your monthly
                repayments, or move the date you pay them.
                <br />
                <br /> There are lots of different{' '}
                <strong>ways we can help,</strong> so please call us on 020 3397
                3375.
            </>
        ),
        readMoreHref:
            'https://support.iwoca.co.uk/en/articles/1608757-how-we-can-help-if-you-miss-a-payment-or-you-re-struggling-to-repay',
        backgroundIcon: <LiveChatSVG />
    }
];
